import type { AccountNames } from "@dealer-center/ddc-api-account-interface";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import ky from "ky";

const queryKeyBase = "ddc-api-account-names";

const url = `/landing/nxlambda/account/names?accounts=`;

const staleTime = 600000; // 10 mins
export function useGetAccountNames(accountNames?: readonly string[]) {
  // remove duplicates, empty strings and sort
  const accountNamesToUse = (accountNames || [])
    .filter((name, index, self) => name && self.indexOf(name) === index)
    .sort();
  return useQuery({
    queryKey: [queryKeyBase, { accountNames: accountNamesToUse }],
    enabled: !!accountNamesToUse.length,
    queryFn: () => fetchAccountGet(accountNamesToUse),
    staleTime,
    // The id list changes whenever a favorite or history entry is added or
    // removed, and each list is its own cache entry. Keeping the previous
    // names while the new list loads stops every consumer from dropping back
    // to "no names" (spinners, id labels, reshuffled favorites) on each change.
    // Consumers must look names up by id, never use this response's order or
    // membership, since the placeholder can belong to a different id list.
    placeholderData: keepPreviousData
  });
}

const fetchAccountGet = (accountNames: string[]) => {
  return ky.get(`${url}${accountNames.join(",")}`).json<AccountNames[]>();
};
